import {
    AUTHENTICATE_USER,
    GET_USER_DATA_FAILED,
    GET_USER_DATA_REQUESTED,
    GET_USER_DATA_SUCCEEDED,
    GET_USER_SYSTEM_NOTIFICATIONS_FAILED,
    GET_USER_SYSTEM_NOTIFICATIONS_REQUESTED,
    GET_USER_SYSTEM_NOTIFICATIONS_SUCCEEDED,
    UPDATE_USER_DATA,
    USER_LOGOUT_REQUEST,
    INSERT_SYSTEM_NOTIFICATION, DELETE_SYSTEM_NOTIFICATION, UPDATE_SYSTEM_NOTIFICATION
} from './actionTypes';

export function authenticateUser(token) {
    return {
        type: AUTHENTICATE_USER,
        token,
    };
}

export function userLogoutRequest() {
    return {
        type: USER_LOGOUT_REQUEST,
    };
}

export function getUserSystemNotificationsRequested() {
    return {
        type: GET_USER_SYSTEM_NOTIFICATIONS_REQUESTED,
    };
}

export function insertSystemNotification(notification) {
    return {
        type: INSERT_SYSTEM_NOTIFICATION,
        payload: {
            notification,
        },
    };
}

export function deleteSystemNotification(id) {
    return {
        type: DELETE_SYSTEM_NOTIFICATION,
        payload: {
            id,
        },
    };
}

export function updateSystemNotification(id) {
    return {
        type: UPDATE_SYSTEM_NOTIFICATION,
        payload: {
            id,
        },
    };
}

export function getUserSystemNotificationsSucceeded(userSystemNotificationsData) {
    return {
        type: GET_USER_SYSTEM_NOTIFICATIONS_SUCCEEDED,
        userSystemNotificationsData,
    };
}

export function getUserSystemNotificationsFailed(err) {
    return {
        type: GET_USER_SYSTEM_NOTIFICATIONS_FAILED,
        err,
    };
}

export function getUserDataRequested() {
    return {
        type: GET_USER_DATA_REQUESTED,
    };
}

export function getUserDataSucceeded(userData) {
    return {
        type: GET_USER_DATA_SUCCEEDED,
        userData,
    };
}

export function getUserDataFailed(err) {
    return {
        type: GET_USER_DATA_FAILED,
        err,
    };
}

export function updateUserData(updateData) {
    return {
        type: UPDATE_USER_DATA,
        payload: {
            updateData,
        },
    };
}



// WEBPACK FOOTER //
// ./src/services/user/action.js